var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    day: true,
    'day-not-in-month': !_vm.inMonth,
    'day-none': !_vm.inMonth && _vm.dayLabel < 14,
    'day-disable': _vm.isDisable,
    'day-highlight': !_vm.isDisable && _vm.highlight,
    'day-active': !_vm.isDisable && _vm.active,
  },on:{"click":function () { return _vm.$emit('dayClick'); }}},[_c('div',{staticClass:"day-content"},[_vm._v("\n    "+_vm._s(_vm.dayLabel)+"\n  ")]),(!_vm.isDisable && _vm.highlight)?_c('div',{staticClass:"day-dot"}):_vm._e(),(!_vm.isDisable && _vm.active && _vm.badge)?_c('div',{staticClass:"day-badge"},[_vm._v("\n    "+_vm._s(_vm.badge)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }